var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-header"},[_c('div',{staticClass:"container"},[_c('h1',{staticClass:"order-header__title"},[_vm._v("\n      "+_vm._s(_vm.$t("services.ordering.pageTitle"))+"\n    ")]),_c('BreadCrumbs',{attrs:{"links":_vm.breadcrumbs}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }